let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ljCe8")).then(() => parcelRequire('iDxDj'));